
import 'components/autocomplete.tag'
import 'components/datetime-picker.tag'
import 'pages/delivery/delivery-list-modal.tag'
import 'pages/persons/persons-company-list-modal.tag'
import 'pages/products/modifications/modifications-list-modal.tag'
import 'pages/payments/payments-list-modal.tag'
import 'pages/payments/payments-add-modal.tag'
import 'pages/orders/order-add-service-modal.tag'
import 'components/loader.tag'
import 'components/catalog.tag'
import 'pages/payments/paysystem-list-modal.tag'
riot.tag2('order-edit', '  <loader if="{loader}"></loader>\n  <virtual hide="{loader}">\n    <div class="btn-group"><a class="btn btn-default" href="#orders/{back}" onclick="{backClick}"><i class="fa fa-chevron-left"></i></a>\n      <button class="btn btn-default {item._edit_ ? &quot;btn-success&quot; : &quot;btn-default&quot;}" if="{isNew ? checkPermission(&quot;orders&quot;, &quot;0100&quot;) : checkPermission(&quot;orders&quot;, &quot;0010&quot;)}" onclick="{submit}" type="button"><i class="fa fa-floppy-o"></i> Сохранить</button>\n      <button class="btn btn-default" if="{!isNew}" onclick="{reloadButton}" title="Обновить" type="button"><i class="fa fa-refresh"></i></button>\n      <button class="btn btn-default" if="{item.id &gt; 0}" onclick="{send}" title="Отослать письмо повторно" type="button"><i class="fa fa-paper-plane {text-noactive: item.send}"></i></button>\n    </div>\n    <button class="btn btn-default" if="{!isNew}" onclick="{showOrderLog}" title="Журнал действий" type="button"><i class="fa fa-list-alt"></i></button>\n    <div class="h4">{isNew ? \'Новый заказ\' : \'Редактирование заказа № \' + item.id}<span if="{item.inStock}">&nbsp;<a href="#orders/stock/{item.inStock}" target="_blank">[партия №{item.inStock}]</a></span>&nbsp;<span class="label label-info" if="{!isNew &amp;&amp; item.isAutoReserved}">Забронирован</span>\n      &nbsp;<span class="label label-{item.stageColor}" if="{!isNew &amp;&amp; item.stageStatus}">{item.stageStatus}</span>&nbsp;<span class="label" if="{item.isPaid &amp;&amp; item.isDelete != &quot;Y&quot;}">\n        <label>\n          <datetime-picker class="form-control" if="{!item.inStock}" name="datePayee" format="YYYY-MM-DD" value="{item.datePayee}" icon="glyphicon glyphicon-calendar"></datetime-picker>\n          <input class="form-control" if="{item.inStock}" value="{item.datePayee}" readonly>\n          <div class="help-block">{error.datePayee}</div>\n        </label></span>\n    </div>\n    <div class="tab-content">\n      <div id="order-edit-home">\n        <form action="" onchange="{change}" onkeyup="{change}" method="POST">\n          <div class="row">\n            <div class="col-md-6">\n              <div class="row">\n                <div class="col-md-2" if="{!isNew}">\n                  <div class="form-group">\n                    <label class="control-label">Ид</label>\n                    <input class="form-control" name="id" value="{item.id}" readonly>\n                  </div>\n                </div>\n                <div class="col-md-4" if="{!isNew}">\n                  <div class="form-group">\n                    <label class="control-label">Дата заказа</label>\n                    <datetime-picker class="form-control" if="{!item.inStock}" name="dateOrder" format="YYYY-MM-DD HH:mm:ss" value="{item.dateOrder}" icon="glyphicon glyphicon-calendar"></datetime-picker>\n                    <input class="form-control" if="{item.inStock}" value="{item.dateOrder}" readonly>\n                  </div>\n                </div>\n                <div class="col-md-6">\n                  <div class="form-group {has-error: (error.idAuthor || error.idCompany)}">\n                    <label class="control-label">Заказчик</label><span class="pull-right">Скидка на момент заказа: {item.personalDiscount}%</span>\n                    <div class="input-group">\n                      <div class="input-group-btn" if="{(item.idAuthor || item.idCompany)}"><a class="btn btn-default" target="_blank" href="{item.idAuthor ? &quot;#persons/&quot; + item.idAuthor : &quot;#persons/companies/&quot; + item.idCompany}"><i class="fa fa-eye"></i></a></div>\n                      <input class="form-control" name="idAuthor" value="{(item.idAuthor || item.idCompany) ? &quot;[&quot; + (item.idAuthor || item.idCompany) + &quot;] - &quot; + item.customerEmail : &quot;&quot;}" readonly>\n                      <div class="input-group-btn">\n                        <div class="btn btn-default" onclick="{changeCustomer}"><i class="fa fa-list"></i></div>\n                      </div>\n                    </div>\n                    <div class="help-block">{(error.idAuthor || error.idCompany)}</div>\n                  </div>\n                </div>\n\n              </div>\n            </div>\n            <div class="col-md-6">\n              <div class="row">\n                <div class="col-md-6">\n                  <div class="form-group">\n                    <label class="control-label">Оплата</label>\n                    <div class="input-group">\n                      <input class="form-control" name="paymentName" value="{item.paymentName}" readonly>\n                      <div class="input-group-btn" onclick="{changePayment}">\n                        <div class="btn btn-default"><i class="fa fa-list"></i></div>\n                      </div>\n                    </div>\n                  </div>\n                </div>\n                <div class="col-md-6">\n                  <div class="form-group">\n                    <label class="control-label">Доставка</label>\n                    <div class="input-group">\n                      <input class="form-control" name="deliveryName" value="{item.deliveryName} {item.deliveryNote}" readonly>\n                      <div class="input-group-btn" onclick="{changeDelivery}">\n                        <div class="btn btn-default"><i class="fa fa-list"></i></div>\n                      </div>\n                    </div>\n                  </div>\n                </div>\n              </div>\n            </div>\n          </div>\n          <div class="row">\n            <div class="col-md-12">\n              <div class="checkbox-inline" if="{!item.inStock &amp;&amp; item.isDelete != &quot;Y&quot;}">\n                <label>\n                  <input type="checkbox" name="isUserPaid" __checked="{item.isUserPaid == 1}">Я оплатил (клиент)\n                </label>\n              </div>\n              <div class="checkbox-inline" if="{!item.inStock &amp;&amp; item.isDelete != &quot;Y&quot;}">\n                <label>\n                  <input type="checkbox" name="isPartPaid" __checked="{item.isPartPaid == 1}" onchange="{partPaidChange}">Оплачен частично\n                </label>\n              </div>\n              <div class="checkbox-inline" if="{!item.inStock &amp;&amp; item.isDelete != &quot;Y&quot;}">\n                <label>\n                  <input type="checkbox" name="isPaid" __checked="{item.isPaid == 1}" onchange="{paidChange}">Оплачен полностью\n                </label>\n              </div>\n              <div class="checkbox-inline" if="{!item.inStock &amp;&amp; item.isDelete != &quot;Y&quot;}">\n                <label>\n                  <input type="checkbox" name="isReserved" __checked="{item.isReserved == 1}" onchange="{reservedChange}">Забронирован\n                </label>\n              </div>\n              <div class="checkbox-inline text-danger pull-right" if="{checkPermission(&quot;settings&quot;, &quot;0010&quot;)}">\n                <label>\n                  <input type="checkbox" name="isFromStock" __checked="{item.isFromStock == 1}">Списать заказ со склада\n                </label>\n              </div>\n            </div>\n          </div><br>\n          <div class="row">\n            <div class="col-md-12">\n              <div class="well well-sm">\n                <catalog-static name="items" rows="{item.items}" cols="{itemsCols}" remove="{true}" handlers="{itemsHandlers}" dblclick="{itemsHandlers.editProduct}">\n                  <yield to="toolbar">\n                    <div class="form-group" if="{true}">\n                      <button class="btn btn-primary" type="button" onclick="{opts.handlers.addProducts}"><i class="fa fa-plus"></i> Добавить товар</button>\n                      <button class="btn btn-primary" type="button" onclick="{opts.handlers.itemsToText}" title="Текст"><i class="fa fa-file-text"></i></button>\n                    </div><span class="pull-right"><strong class="text-muted pull-left">Курс BTC: {parent.item.btc}</strong><br><strong class="text-muted pull-left">Курс USDT: {parent.item.usdt}</strong></span>\n                  </yield>\n                  <yield to="body">\n                    <datatable-cell name="article" style="max-width: 60px;">\n                      <input value="{row.article}" type="text" readonly>\n                    </datatable-cell>\n                    <datatable-cell name="nameBrand" style="max-width: 120px;">\n                      <input value="{row.nameBrand}" type="text" readonly>\n                    </datatable-cell>\n                    <datatable-cell name="name" style="min-width: 200px;">\n                      <input value="{row.name}" type="text" readonly>\n                    </datatable-cell>\n                    <datatable-cell class="bg-info" name="count" style="max-width: 20px;">\n                      <input value="{row.count}" step="1" min="1" onchange="{handlers.numberChange}" type="{\'number\'}">\n                    </datatable-cell>\n                    <datatable-cell class="bg-warning" name="stock" style="max-width: 50px;">{row.stock}</datatable-cell>\n                    <datatable-cell class="bg-info" name="price" style="max-width: 50px;">\n                      <input value="{row.price}" step="1.00" min="0" onchange="{handlers.numberChange}" type="{\'number\'}">\n                    </datatable-cell>\n                    <datatable-cell class="bg-info" name="amount1" style="max-width: 25px;">{(row.count * row.price).toFixed(0)}</datatable-cell>\n                    <datatable-cell class="bg-warning" name="personal" style="max-width: 25px;">{row.percentPersonal.toFixed(0)}</datatable-cell>\n                    <datatable-cell class="bg-warning" name="coupon" style="max-width: 25px;">{row.percentCoupon.toFixed(0)}</datatable-cell>\n                    <datatable-cell class="bg-warning" name="action" style="max-width: 25px;">{row.percentAction.toFixed(0)}</datatable-cell>\n                    <datatable-cell class="bg-danger" name="discountPercent" style="max-width: 25px;">\n                      <input value="{(row.discount / row.price * 100).toFixed(0)}" step="0.01" min="0" onchange="{handlers.numberChange2}" type="{\'number\'}">\n                    </datatable-cell>\n                    <datatable-cell class="bg-danger" name="discount" style="max-width: 25px;">\n                      <input value="{row.discount}" step="1.00" min="0" onchange="{handlers.numberChange}" type="{\'number\'}">\n                    </datatable-cell>\n                    <datatable-cell class="bg-info text-danger" name="price2" style="max-width: 25px;">{((row.price - row.discount)).toFixed(0).toLocaleString()}</datatable-cell>\n                    <datatable-cell class="bg-info" name="amount" style="max-width: 25px;">{(row.count * (row.price - row.discount)).toFixed(0).toLocaleString()}</datatable-cell>\n                  </yield>\n                </catalog-static>\n                <div class="alert alert-danger" if="{error.items}">{error.items}</div>\n                <div class="row">\n                  <div class="col-md-10">\n                    <div class="pull-right">\n                      <label>Сумма товаров:</label><strong class="text-info"> {amountProducts}</strong>\n                    </div>\n                  </div>\n                  <div class="col-md-2" if="{item.paymentName}">\n                    <label>{item.paymentName}:</label><strong class="text-success {text-danger: discountPayment &gt; 0}"> {discountPayment}</strong>\n                  </div>\n                </div>\n                <div class="row">\n                  <div class="col-md-10">\n                    <div class="pull-right">\n                      <label>Доставка ({item.deliveryName}):</label><strong class="text-info"> {amountDelivery}</strong>\n                    </div>\n                  </div>\n                  <div class="col-md-2">\n                    <label>Итого к оплате:</label><strong class="text-primary"> {amountTotal}</strong>\n                  </div>\n                </div>\n                <div class="row">\n                  <div class="col-md-10">\n                    <div class="pull-right">\n                      <label>Скидка:</label><strong class="text-success"> {-discountOrder}</strong>\n                    </div>\n                  </div>\n                  <div class="col-md-2">\n                    <label>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;BTC:</label><strong class="text-primary"> {amountTotalBTC}</strong>\n                  </div>\n                </div>\n                <div class="row">\n                  <div class="col-md-10">\n                    <div class="pull-right">\n                      <label>Итого заказ:</label><strong class="text-info"> {amountOrder}</strong>\n                    </div>\n                  </div>\n                  <div class="col-md-2">\n                    <label>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;USDT:</label><strong class="text-primary"> {amountTotalUSDT}</strong>\n                  </div>\n                </div>\n              </div>\n            </div>\n          </div>\n          <div class="h4">Информация о доставке/оплате</div>\n          <div class="row">\n            <div class="col-md-6">\n\n              <div class="form-group">\n                <label class="control-label">Реквизиты</label>\n                <input class="form-control" name="requisites" value="{item.requisites}">\n              </div>\n              <div class="form-group">\n                <label class="control-label">Карта заказчика</label>\n                <input class="form-control" name="cardUser" value="{item.cardUser}">\n              </div>\n              <div class="form-group">\n                <div class="pull-right">\n                  <div class="checkbox-inline">\n                    <label>\n                      <input type="checkbox" name="isSendCard" __checked="{item.isSendCard}">Отправить карту\n                    </label>\n                  </div>\n                </div>\n                <label class="control-label">Карта для перевода</label>\n                <input class="form-control" name="cardTransfer" value="{item.cardTransfer}" __disabled="{!item.isSendCard}">\n              </div>\n\n              <div class="form-group">\n                <label class="control-label">Пункт доставки</label>\n                <input class="form-control" name="subDelivery" value="{item.subDelivery} ">\n              </div>\n              <div class="form-group">\n                <label class="control-label">Стоимость доставки</label>\n                <input class="form-control" name="deliveryPayee" value="{item.deliveryPayee}" min="0" type="{\'number\'}">\n              </div>\n\n              <div class="form-group">\n                <label class="control-label">Комментарий заказчика</label>\n                <textarea class="form-control" rows="3" name="commentary" style="min-width: 100%; max-width: 100%;" value="{item.commentary}"></textarea>\n              </div>\n            </div>\n            <div class="col-md-6">\n\n              <div class="form-group">\n                <label class="control-label">ФИО</label>\n                <input class="form-control" name="nameRecipient" value="{item.nameRecipient}">\n              </div>\n              <div class="form-group">\n                <label class="control-label">Адрес</label>\n                <input class="form-control" name="address" style="min-width: 100%; max-width: 100%;" value="{item.address}">\n              </div>\n              <div class="form-group">\n                <label class="control-label">Почтовый индекс</label>\n                <input class="form-control" name="postindex" value="{item.postindex}">\n              </div>\n              <div class="form-group">\n                <label class="control-label">Телефон</label>\n                <input class="form-control" name="telnumber" value="{item.telnumber}">\n                <div class="help-block">{error.telnumber}</div>\n              </div>\n              <div class="form-group">\n                <label class="control-label">Трек номер</label>\n                <input class="form-control" name="track" value="{item.track}" readonly>\n              </div>\n\n              <div class="form-group">\n                <label class="control-label">Примечание администратора</label>\n                <textarea class="form-control" rows="3" name="adminCommentary" style="min-width: 100%; max-width: 100%;" value="{item.adminCommentary}"></textarea>\n              </div>\n            </div>\n          </div>\n        </form>\n      </div>\n    </div>\n  </virtual>\n', '.text-noactive { color: #cccccc; }', '', function(opts) {
'use strict';

var _assign = require('babel-runtime/core-js/object/assign');

var _assign2 = _interopRequireDefault(_assign);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var self = this,
    route = riot.route.create();

self.isNew = false;
self.item = {};
self.loader = false;
self.sumProducts = 0;
self.total = 0;
self.snd = false;
self.back = '';
self.personalDiscount = 5;

self.mixin('validation');
self.mixin('permissions');
self.mixin('change');

self.backClick = function () {
    if (history.length > 2) history.back();else return true;
};

self.send = function () {
    if (self.item.send) {
        return;
    }
    self.item.send = true;
    var params = {
        id: self.item.id,
        sendcode: 'orduserch'
    };
    API.request({
        object: 'Order',
        method: 'SendMail',
        data: params,
        success: function success(response) {
            self.snd = false;
        }
    });

    self.update();
};

self.rules = function () {

    self.debuger((0, _extends3.default)({}, self.debugParam, { method: "rules" }));

    var rules = {
        items: {
            required: true,
            rules: [{
                type: 'minLength[1]',
                prompt: 'В списке должно быть не менее одного элемента'
            }]
        }
    };

    if (self.item.isPaid) rules.datePayee = 'empty';

    if (self.item && (self.item.idAuthor || self.item.idCompany)) return (0, _extends3.default)({}, rules);else return (0, _extends3.default)({}, rules, { idAuthor: 'empty' });
};

self.changeStatus = function (e) {

    self.debuger((0, _extends3.default)({}, self.debugParam, { method: "changeStatus" }));

    if (e.target.value == 'Y') {
        self.addPayment();
    }
};

self.afterChange = function (e) {

    self.debuger((0, _extends3.default)({}, self.debugParam, { method: "afterChange" }));
    var name = e.target.name;
    delete self.error[name];
    self.error = (0, _extends3.default)({}, self.error, self.validation.validate(self.item, self.rules(), name));
};

self.dynFieldsChange = function (e) {

    self.debuger((0, _extends3.default)({}, self.debugParam, { method: "dynFieldsChange" }));
    var type = e.item.field.type;

    if (type !== 'checkbox') {
        e.item.field.value = e.target.value;
    } else {
        var checkedValues = (e.item.field.value || '').split(',');
        var checkedValue = e.target.getAttribute('data-value');
        var idx = checkedValues.indexOf(checkedValue);

        if (idx !== -1) checkedValues.splice(idx, 1);else checkedValues.push(checkedValue);

        e.item.field.value = checkedValues.filter(function (i) {
            return i;
        }).join(',');
    }
};

self.itemsCols = [{ name: 'article', value: 'Артикул' }, { name: 'nameBrand', value: 'Сидбанк' }, { name: 'name', value: 'Наименование' }, { name: 'count', value: 'Кол-во' }, { name: 'stock', value: 'Остаток' }, { name: 'price', value: 'Цена1' }, { name: 'amount1', value: 'Сумма1' }, { name: 'personal', value: 'Накоп.' }, { name: 'coupon', value: 'Промо' }, { name: 'action', value: 'Акция' }, { name: 'discountPercent', value: 'Скидка, %' }, { name: 'discount', value: 'Скидка, р.' }, { name: 'price2', value: 'Цена2' }, { name: 'amount', value: 'Сумма2' }];

self.displayFormat = function (price) {

    self.debuger((0, _extends3.default)({}, self.debugParam, { method: "displayFormat" }));

    return Math.ceil(price);

    if (self.currPrefix != null) return self.currPrefix + ' ' + price.toLocaleString();
    if (self.currSuffix != null) return price.toLocaleString() + ' ' + self.currSuffix;
};

self.displayFormatBTC = function (price) {
    return price.toLocaleString() + ' BTC';
};

self.paidChange = function (e) {
    if (!self.item.isPaid) {
        self.item.datePayee = new Date().toISOString().split('T')[0];
        self.item.isPartPaid = 0;
        self.item.isReserved = 0;
    }
};

self.partPaidChange = function (e) {
    if (!self.item.isPartPaid) {
        self.item.isPaid = 0;
        self.item.isReserved = 0;
    }
};

self.reservedChange = function (e) {
    if (!self.item.isReserved) {
        self.item.isPaid = 0;
        self.item.isPartPaid = 0;
    }
};

/** элементы Обработчики */
self.itemsHandlers = {
    numberChange: function numberChange(e) {
        self.debuger((0, _extends3.default)({}, self.debugParam, { method: "numberChange" }));
        this.row[this.opts.name] = e.target.value;
    },
    numberChange2: function numberChange2(e) {
        this.row['discount'] = (this.row['price'] * e.target.value / 100).toFixed(2);
        //console.log(this.row['discount'])
    },
    stringChange: function stringChange(e) {
        self.debuger((0, _extends3.default)({}, self.debugParam, { method: "stringChange" }));
        this.row[this.opts.name] = e.target.value;
    },
    addServices: function addServices() {
        self.debuger((0, _extends3.default)({}, self.debugParam, { method: "addServices" }));
        modals.create('order-add-service-modal', {
            type: 'modal-primary',
            size: 'modal-lg',
            submit: function submit() {
                var _this = this;
                if (_this.item.name && _this.item.count > 0) {
                    _this.item.curr = self.item.curr;
                    self.item.items = self.item.items || [];
                    self.item.items.push(_this.item);
                    self.update();
                    this.modalHide();
                }
            }
        });
    },
    addProducts: function addProducts() {

        self.debuger((0, _extends3.default)({}, self.debugParam, { method: "addProducts" }));

        self.debuger((0, _extends3.default)({}, self.debugParam, { method: "addProducts",
            groupLog: "addProdD", dComment: ">Добавить self.item.items",
            dArray: self.item.items }));

        var order = self.item;
        modals.create('products-list-select-modal', {
            type: 'modal-primary',
            size: 'modal-lg',
            submit: function submit() {

                self.debuger((0, _extends3.default)({}, self.debugParam, { method: "addProducts",
                    groupLog: "addProdD", dComment: "submit данные добавлены",
                    dArray: self.item.items }));

                var _this = this;
                var items = _this.tags.catalog.tags.datatable.getSelectedRows();
                self.item.items = self.item.items || [];

                if (items.length > 0) {
                    if ('countModifications' in items[0] && items[0].countModifications > 0) {
                        (function () {
                            var idPrice = items[0].id;
                            var brand = items[0].nameBrand;
                            var article = items[0].article;
                            var discountValue = items[0].discount;
                            var additionalDiscount = items[0].additionalDiscount;
                            modals.create('modifications-list-modal', {
                                type: 'modal-primary',
                                size: 'modal-lg',
                                id: items[0].id,
                                submit: function submit() {
                                    var items = this.tags['catalog-static'].tags.datatable.getSelectedRows();
                                    items.forEach(function (item) {
                                        var discount = Math.round(item.price * (Math.max(discountValue, self.item.personalDiscount) + additionalDiscount)) / 100;
                                        self.item.items.push((0, _extends3.default)({}, item, { count: 1, discount: discount, id: null, idPrice: idPrice, nameBrand: brand, idsModifications: item.id, article: article, discountValue: discountValue, additionalDiscount: additionalDiscount }));
                                    });
                                    self.update();
                                    this.modalHide();
                                    _this.modalHide();

                                    var event = document.createEvent('Event');
                                    event.initEvent('change', true, true);
                                    self.tags.items.root.dispatchEvent(event);
                                }
                            });
                        })();
                    } else {
                        (function () {
                            var ids = self.item.items.map(function (item) {
                                return item.id;
                            });

                            var discount = 0;

                            items.forEach(function (item) {
                                if (ids.indexOf(item.id) === -1) {
                                    self.debuger((0, _extends3.default)({}, self.debugParam, { method: "addProducts",
                                        groupLog: "addProdD", dComment: "до добавления массив item",
                                        dArray: item }));

                                    self.debuger((0, _extends3.default)({}, self.debugParam, { method: "addProducts",
                                        groupLog: "addProdD", dComment: "до добавления self.item.items",
                                        dArray: self.item.items }));

                                    discount = Math.round(item.price * (Math.max(item.discount, self.item.personalDiscount) + item.additionalDiscount)) / 100;

                                    self.item.items.push((0, _extends3.default)({}, item, { count: 1, discount: discount, id: null, idPrice: item.id, discountValue: item.discount, additionalDiscount: item.additionalDiscount }));
                                }
                            });

                            self.update();
                            _this.modalHide();

                            var event = document.createEvent('Event');
                            event.initEvent('change', true, true);
                            self.tags.items.root.dispatchEvent(event);
                        })();
                    }
                }

                // self.convertPrices()
            }
        });
    },
    editProduct: function editProduct(e) {

        self.debuger((0, _extends3.default)({}, self.debugParam, { method: "editProduct" }));

        var oldItem = (0, _assign2.default)({}, e.item.row);
        var index = -1;
        self.item.items.forEach(function (item, i) {
            if (item.id === oldItem.id) index = i;
        });

        if (oldItem.idPrice) {

            if (oldItem["idsModifications"]) {
                modals.create('modifications-list-modal', {
                    type: 'modal-primary',
                    size: 'modal-lg',
                    id: oldItem.idPrice,
                    submit: function submit() {
                        var items = this.tags['catalog-static'].tags.datatable.getSelectedRows();
                        if (items.length > 0) {
                            self.item.items[index] = (0, _extends3.default)({}, items[0]);
                            self.item.items[index].id = oldItem.id;
                            self.item.items[index].count = oldItem.count;
                            self.item.items[index].discount = oldItem.discount;
                            self.item.items[index].idPrice = oldItem.idPrice;
                            self.item.items[index].idsModifications = items[0].id;
                        }

                        self.update();
                        this.modalHide();

                        var event = document.createEvent('Event');
                        event.initEvent('change', true, true);
                        self.tags.items.root.dispatchEvent(event);
                    }
                });
            } else {
                var filters = {
                    field: 'id',
                    value: e.item.row.idPrice
                };
                modals.create('products-list-select-modal', {
                    type: 'modal-primary',
                    size: 'modal-lg',
                    systemFilters: filters,
                    submit: function submit() {
                        var _this = this;
                        var items = _this.tags.catalog.tags.datatable.getSelectedRows();
                        if (items.length > 0) {
                            self.item.items[index] = (0, _extends3.default)({}, items[0]);
                            self.item.items[index].id = oldItem.id;
                            self.item.items[index].count = oldItem.count;
                            self.item.items[index].discount = oldItem.discount;
                            self.item.items[index].idPrice = oldItem.id;
                        }

                        self.update();
                        _this.modalHide();

                        var event = document.createEvent('Event');
                        event.initEvent('change', true, true);
                        self.tags.items.root.dispatchEvent(event);
                    }
                });
            }
        } else {}
    },
    itemsToText: function itemsToText(e) {
        modals.create('order-items-to-text', {
            type: 'modal-primary',
            size: 'modal-lg',
            item: self.item,
            submit: function submit(e) {
                this.modalHide();
            }
        });
    }
};

self.showOrderLog = function (e) {
    modals.create('order-log', {
        type: 'modal-primary',
        size: 'modal-lg',
        item: self.item,
        submit: function submit(e) {
            this.modalHide();
        }
    });
};

self.orderItems = {
    Y: 'Оплачен', N: 'Не оплачен', A: 'Предоплата', D: 'Отказ', K: 'Кредит', P: 'Подарок', W: 'В ожидании', C: 'Возврат', T: 'Тест'
};

self.deliveryItems = {
    Y: 'Доставлен', N: 'Не доставлен', M: 'В работе', P: 'Отправлен'
};

self.changeDelivery = function () {
    self.debuger((0, _extends3.default)({}, self.debugParam, { method: "changeDelivery" }));
    modals.create('delivery-list-modal', {
        type: 'modal-primary',
        size: 'modal-lg',
        submit: function submit() {
            var _this = this;
            var items = _this.tags.catalog.tags.datatable.getSelectedRows();
            self.item.deliveryName = items[0].name;
            self.item.deliveryType = items[0].id;
            self.item.deliveryPayee = items[0].price;
            self.update();
            this.modalHide();
        }
    });
};

self.changePayment = function () {
    self.debuger((0, _extends3.default)({}, self.debugParam, { method: "changePayment" }));
    modals.create('paysystem-list-modal', {
        type: 'modal-primary',
        size: 'modal-lg',
        submit: function submit() {
            var _this = this;
            var items = _this.tags.catalog.tags.datatable.getSelectedRows();
            self.item.paymentName = items[0].name;
            self.item.paymentDiscount = items[0].discount;
            self.item.paymentType = items[0].id;
            self.item.requisites = items[0].requisites;
            self.update();
            this.modalHide();
        }
    });
};

self.changeCustomer = function () {
    self.debuger((0, _extends3.default)({}, self.debugParam, { method: "changeCustomer" }));
    modals.create('persons-company-list-modal', {
        type: 'modal-primary',
        size: 'modal-lg',
        submit: function submit() {
            var _this = this.tags['bs-modal'];
            var items = _this.tags[_this.tab].tags.datatable.getSelectedRows();
            if (!items.length) return;

            if (_this.tab == 'contacts') {
                self.item.idAuthor = items[0].id;
                self.item.customer = items[0].displayName;
                self.item.customerEmail = items[0].email;
                self.item.idCompany = null;
                self.item.personalDiscount = Math.max(items[0].discount, items[0].progressiveDiscount);
                if (self.isNew && self.item.items) {
                    self.item.items.forEach(function (item, i) {
                        item.discount = Math.round(item.price * (Math.max(item.discountValue, self.item.personalDiscount) + item.additionalDiscount)) / 100;
                    });
                }
            } else {
                self.item.idCompany = items[0].id;
                self.item.customer = items[0].name;
                self.item.idAuthor = null;
                self.item.customerEmail = items[0].email;
            }

            self.update();
            this.modalHide();
        }
    });
};

self.addPayment = function () {

    /** ПЕРЕРАСЧЕТ ДОПЛАТЫ
     *  1 подсчет суммы оплаты
     *  2 подсчет суммы стоимости
     *  3 подсчет cуммы оставшейся оплаты
     */

    self.debuger((0, _extends3.default)({}, self.debugParam, { method: "addPayment" }));

    var sumAmountItems = 0;
    var totalValue = 0;
    self.item.payments.forEach(function (item) {
        sumAmountItems += item.amount;
    }); // 1
    self.item.items.forEach(function (item) {
        totalValue += item.count * item.price - item.discount;
    }); // 2
    self.item.paid = sumAmountItems;
    self.item.surcharge = (totalValue - sumAmountItems).toFixed(2); // 3

    /**
     * @param {array}   self.item.payments     строки платежей
     * @param {str/int} _this.item.paymentType тип платежа
     */

    self.debuger((0, _extends3.default)({}, self.debugParam, { method: "addPayment",
        groupLog: "addPayment", dComment: "данные в payments-add-modal",
        dArray: self.item }));

    modals.create('payments-add-modal', {
        type: 'modal-primary',
        size: 'modal-lg',
        order: self.item,
        submit: function submit() {
            var _this = this;
            if (_this.submit()) {

                var params = _this.item;

                self.debuger((0, _extends3.default)({}, self.debugParam, { method: "addPayment",
                    groupLog: "addPayment", dComment: "из всплывающего params",
                    dArray: params }));

                params["nameFront"] = self.item.pageCurr.nameFront;
                params["titleCurr"] = self.item.pageCurr.title;

                self.getPaymentTypeName(params);
                params.payer = self.item.customer;
                params.orderAmount = self.item.amount;
                if (_this.item.amount + self.item.paid >= self.item.amount) {
                    self.item.status = 'Y';
                    self.item.datePayee = _this.item.date;
                    self.update();
                }

                /** @param {object} params данные платежа */
                self.item.payments.push(params);
                observable.trigger('datacatalog', { "OrderPaymen": self.item.payments });

                self.update();
                self.tags.catalog.reload();
                this.modalHide();
            }
        }
    });
};

self.getPaymentTypeName = function (params) {

    /** получить имя платежной системы
     * @param  {array}   params.paymentTypeNames данные по типам платежей
     * @param  {int/str} params.paymentType      id типа платежа
     * @return {str}     params.name             имя платежной
     */

    self.debuger((0, _extends3.default)({}, self.debugParam, { method: "getPaymentTypeName" }));

    var paySystemsId = {};
    params.paymentTypeNames.forEach(function (item) {
        paySystemsId[item["id"]] = item;
    });
    params.name = paySystemsId[Number(params.paymentType)]["name"];
    delete params.paymentTypeNames;
};

self.removePayment = function (e, itemsToRemove, self) {

    /** удаление групп из временного списка
     *  (нужно, что бы все группы были на листе - нужны id для allDelete)
     *  @param  {object}          e             MouseEvent данные мыши
     *  @param  {array or object} itemsToRemove массив id's на удаление или объект с allMode and allModeLastParams
     *  @param  {object}          self          данные по контакту
     *  @return {object}          observable.trigger 'datacatalog'
     */

    self.debuger((0, _extends3.default)({}, self.debugParam, { method: "removePayment" }));

    /** если "удалить все" - получаем список id групп для последующего удаления */
    if (itemsToRemove.allMode != undefined) {
        itemsToRemove = [];
        self.items.forEach(function (item) {
            itemsToRemove.push(item.id);
        });
    }

    var iddatacatalog = {};
    self.datacatalog.OrderPaymen.forEach(function (item) {
        // получаем id
        iddatacatalog[item.id] = item;
    });
    self.datacatalog.OrderPaymen = []; // чистим

    itemsToRemove.forEach(function (item) {
        delete iddatacatalog[item]; // удаляем по id
    });

    for (var item in iddatacatalog) {
        // возвращаем
        self.datacatalog.OrderPaymen.push(iddatacatalog[item]);
    }
    observable.trigger('datacatalog', self.datacatalog); // записываем в транс-табличные данные

    self.update();
    return true;
};

self.convertPrices = function () {

    self.debuger((0, _extends3.default)({}, self.debugParam, { method: "convertPrices" }));

    self.debuger((0, _extends3.default)({}, self.debugParam, { method: "convertPrices",
        groupLog: "addProdD", dComment: "при конвертации self.item.items",
        dArray: self.item.items }));

    self.item.items.forEach(function (item, i) {
        if (item.curr != self.item.curr) {

            self.debuger((0, _extends3.default)({}, self.debugParam, { method: "convertPrices",
                groupLog: "addProdD", dComment: "конвертация item.price",
                dArray: { 'price': item.price, 'source': item.curr, 'target': self.item.curr, 'item': item } }));

            var params = { 'price': item.price, 'source': item.curr, 'target': self.item.curr };
            API.request({
                object: 'Currency',
                method: 'CONVERT',
                data: params,
                success: function success(response) {
                    item.price = response.price;
                    item.curr = self.item.curr;
                    self.update();
                }
            });
        }
    });
};

self.submit = function (e) {

    self.debuger((0, _extends3.default)({}, self.debugParam, { method: "submit" }));

    /** @param {array} self.payments нумерованный массив платежей */

    var paramsPayments = { "payments": self.item.payments,
        "idOrder": self.item.id };
    var params = self.item;
    params.send = self.snd;

    self.error = self.validation.validate(self.item, self.rules());

    self.debuger((0, _extends3.default)({}, self.debugParam, { method: "submit",
        groupLog: "submit", dComment: "API Payment Save", dArray: paramsPayments }));

    self.debuger((0, _extends3.default)({}, self.debugParam, { method: "submit",
        groupLog: "submit", dComment: "API Order Save", dArray: params }));

    if (!self.error) {
        API.request({
            object: 'Order',
            method: 'Save',
            data: params,
            success: function success(response) {
                self.item = response;
                self.isNew = false;

                self.update();
                if (self.isNew) riot.route('/orders/' + self.item.id);
                popups.create({ title: 'Успех!', text: 'Заказ сохранен!', style: 'popup-success' });
                if (self.tags.catalog) self.tags.catalog.reload(); // перезагрузка каталога
                //observable.trigger('orders-reload')
            }
        });
    }
};

self.reloadButton = function () {

    /** обновление страницы карточки контакта с всплывающим предупреждением */

    self.debuger((0, _extends3.default)({}, self.debugParam, { method: "reloadButton" }));

    modals.create('bs-alert', {
        type: 'modal-danger',
        title: 'Предупреждение',
        text: 'Будут потеряны не сохраненные данные. Вы точно хотите обновить эту страницу?',
        size: 'modal-sm',
        buttons: [{ action: 'yes', title: 'Обновить', style: 'btn-danger' }, { action: 'no', title: 'Отмена', style: 'btn-default' }],
        callback: function callback(action) {
            if (action === 'yes') {
                self.reload();
            }
            this.modalHide();
        }
    });
};

self.reload = function (e) {
    self.debuger((0, _extends3.default)({}, self.debugParam, { method: "reload" }));
    observable.trigger('orders-edit', self.item.id);
}; // перезагрузить

self.on('update', function () {

    if (self.item && self.item.items) {
        self.sumProducts = self.item.items.map(function (i) {
            return i.count * i.price;
        }).reduce(function (p, c) {
            return p + c;
        }, 0);
        self.sumProductsDsc = self.item.items.map(function (i) {
            return i.count * (i.price - i.discount);
        }).reduce(function (p, c) {
            return p + c;
        }, 0);
        if (self.sumProductsDsc < 0) self.sumProductsDsc = 0;
        var summ = parseFloat(self.sumProductsDsc || 0) - parseFloat(self.item.discount || 0);
        if (summ < 0) summ = 0;
        if (parseFloat(self.sumProducts) > 0) self.total = summ + parseFloat(self.item.deliveryPayee || 0);else self.total = 0;
        //self._amount = self.total + self.total * parseFloat(self.item.paymentDiscount || 0) / 100
        self.discountOrder = self.displayFormat(self.sumProducts - self.sumProductsDsc);
        if (self.discountOrder < self.item.coupon) {
            self.total += self.discountOrder;
            self.discountOrder = self.item.coupon;
            self.total -= self.discountOrder;
        }

        self.discountPayment = self.displayFormat(self.total * parseFloat(self.item.paymentDiscount || 0) / 100);
        self.amountProducts = self.displayFormat(self.sumProducts);
        self.amountTotal = self.displayFormat(self.item.amount);
        self.amountTotalBTC = self.displayFormat(self.item.amount / self.item.btc * 100000) / 100000;
        self.amountTotalUSDT = self.displayFormat(self.item.amount / self.item.usdt * 100) / 100;
        self.amountOrder = self.displayFormat(self.total);
        //self.amountOrderBTC = self.displayFormatBTC((self.total / self.item.btc).toFixed(5))
        //self.amountProductsBTC = self.displayFormatBTC((self.sumProducts / self.item.btc).toFixed(5))
        //self.amountProductsWithDiscount = self.displayFormat(self.sumProductsDsc)
        //self.amountProductsWithDiscountBTC = self.displayFormatBTC((self.sumProductsDsc / self.item.btc).toFixed(5))
        self.amountDelivery = self.displayFormat(parseFloat(self.item.deliveryPayee || 0));
    }
});

self.on('mount', function () {
    riot.route.exec();
});

observable.on('order-new', function () {

    self.debuger((0, _extends3.default)({}, self.debugParam, { method: "order-new" }));

    self.error = false;
    self.isNew = true;
    self.sumProducts = 0;
    self.item = {
        deliveryPayee: 0,
        personalDiscount: 0,
        discount: 0,
        status: 'N',
        statusOrder: 'N',
        deliveryStatus: 'N',
        idAdmin: null,
        isReserved: 1
    };
    if (app.config.idUser && app.config.idUser != 'admin') self.item.idAdmin = app.config.idUser;
    self.total = 0;
    self.update();
    self.getManagers();
    self.getBaseCurrency();

    API.request({
        object: 'Order',
        method: 'fetchBtc',
        data: {},
        success: function success(response) {
            if (response && response.btc) self.item.btc = response.btc;
        }
    });
});

observable.on('orders-edit', function (id) {
    self.debuger((0, _extends3.default)({}, self.debugParam, { method: "orders-edit" }));

    self.debuger((0, _extends3.default)({}, self.debugParam, { method: "orders-edit",
        groupLog: "ordersEdit", dComment: "self start",
        dArray: self }));

    var params = { id: id };
    params["curr"] = self.item.curr;
    self.error = false;
    self.isNew = false;
    self.item = {};
    self.loader = true;
    self.back = '';
    self.update();
    self.getManagers();

    var query = riot.route.query();

    if (query && query.back) self.back = query.back;

    API.request({
        object: 'Order',
        method: 'Info',
        data: params,
        success: function success(response) {
            self.debuger((0, _extends3.default)({}, self.debugParam, { method: "orders-edit",
                groupLog: "ordersEdit", dComment: "response", dArray: response }));
            self.item = response;
            self.loader = false;
            self.getBaseCurrency();
            self.update();
            if (self.tags.catalog && self.catalogReload) self.tags.catalog.reload({ dcreset: true }); // перезагрузка каталога
            self.catalogReload = true; // перезагружать каталог, только после первой прогрузки
        }
    });
});

observable.on('datacatalog', function (e) {

    self.debuger((0, _extends3.default)({}, self.debugParam, { method: "datacatalog" }));

    /** получение транс-табличных данных
     *  @param {object} e именаТаблиц-массивыСтрок
     *  @return {object} observable.trigger 'datacatalog'
     */

    self.datacatalog = e;
    self.item.payments = self.datacatalog.OrderPaymen;
});

self.getManagers = function () {
    self.debuger((0, _extends3.default)({}, self.debugParam, { method: "getManagers" }));
    self.debuger((0, _extends3.default)({}, self.debugParam, { method: "getManagers", groupLog: "getManagers", dComment: "self", dArray: self }));
    self.managers = [];
    API.request({
        object: 'PermissionUser',
        method: 'Fetch',
        success: function success(response) {
            self.managers = response.items;
            self.update();
        }
    });
};

self.getBaseCurrency = function () {
    self.debuger((0, _extends3.default)({}, self.debugParam, { method: "getBaseCurrency" }));
    API.request({
        object: 'Main',
        method: 'Info',
        success: function success(response) {
            if (!self.item.curr) self.item.curr = response.basecurr;
            self.basecurr = response.basecurr;
            response.listCurrency.forEach(function (item) {
                if (item.name.toLowerCase() == self.item.curr.toLowerCase()) {
                    self.currSuffix = item.nameFlang;
                    self.currPrefix = item.nameFront;
                }
            });
            self.update();
        }
    });
};

self.debugParam = {
    module: "order-edit.tag",
    dClass: "ord-ed",
    method: "",
    dComment: "",
    groupLog: "norm",
    dArray: undefined
};
self.debuger = function () {
    var dp = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : self.debugParam;

    /** ДЕБАГЕР
     * 1 Запуск логов
     * 2 Настройки
     * 3 Формирование строки
     * 4 Отступ
     * 5 Очередность и отображение
     *
     * self.debuger({ ...self.debugParam, method:"allParams" })
     *
     * self.debuger({ ...self.debugParam, method:"reload",
     *                groupLog: "reload", dComment:"response", dArray: response })
     */

    // 1
    var startList = {
        norm: true,
        addProdD: false,
        submit: false,
        addPayment: false,
        ordersEdit: false,
        getManagers: false
    };

    if (startList[dp.groupLog] == true && document.domain == "localhost") {

        // 2
        var ind = 30;var ind2 = 12;var sy = " ";var col = " |";
        var gr = true;var com = true;var met = true;var cl = true;var mod = true;

        // 3
        var groupLog = "gr: " + dp.groupLog;
        var comment = "com: " + dp.dComment;
        var method = "met: " + dp.method;
        var clas = "cl: " + dp.dClass;
        var module = "mod: " + dp.module;

        // 4
        var groupLogLen = sy.repeat(ind2 - groupLog.length >= 0 ? ind2 - groupLog.length : 0) + col;
        var commentLen = sy.repeat(ind - comment.length >= 0 ? ind - comment.length : 0) + col;
        var methodLen = sy.repeat(ind - method.length >= 0 ? ind - method.length : 0) + col;
        var clasLen = sy.repeat(ind - clas.length >= 0 ? ind - clas.length : 0) + col;
        var modLen = sy.repeat(ind - module.length >= 0 ? ind - module.length : 0) + col;

        // 5
        var consoleLog = "|";
        if (gr == true) consoleLog += groupLog + groupLogLen;
        if (com == true) consoleLog += comment + commentLen;
        if (met == true) consoleLog += method + methodLen;
        if (cl == true) consoleLog += clas + clasLen;
        if (mod == true) consoleLog += module + modLen;

        console.warn(consoleLog);
        if (dp.dArray != undefined) console.log(dp.dArray);
    }
};
});
riot.tag2('order-items-to-text', '  <bs-modal>\n    <yield to="title">\n      <div class="h4 modal-title">Состав заказа № {item.id}</div>\n    </yield>\n    <yield to="body">\n      <div class="row">\n        <div class="col-md-12">\n          <button class="btn btn-primary" onclick="{parent.textCopy}" type="button"><i class="fa fa-copy"></i></button>\n          <textarea class="form-control" id="textItems" rows="6" style="min-width: 100%; mi-width: 100%;">{item.text}</textarea>\n        </div>\n      </div>\n    </yield>\n    <yield to="footer">\n      <button class="btn btn-default btn-embossed" onclick="{modalHide}" type="button">Закрыть</button>\n    </yield>\n  </bs-modal>\n', '', '', function(opts) {
'use strict';

var self = this;

self.textCopy = function () {
    textItems.select();
    document.execCommand("copy");
};

self.on('mount', function () {
    var modal = self.tags['bs-modal'];
    modal.mixin('change');
    modal.item = opts.item || {};
    modal.item.text = opts.item.items.map(function (row) {
        return row.nameBrand + ' ' + row.name + ' ' + row.count;
    }).reduce(function (text, row) {
        return text + '\n' + row;
    });
    self.update();
});
});
riot.tag2('order-log', '  <bs-modal>\n    <yield to="title">\n      <div class="h4 modal-title">Журнал действий по заказу № {item.id}</div>\n    </yield>\n    <yield to="body">\n      <div class="row">\n        <div class="col-md-12">\n          <datatable cols="{parent.logCols}" rows="{item.log}">\n            <datatable-cell name="action" style="max-width: 60px;">{row.action}</datatable-cell>\n            <datatable-cell name="user" style="max-width: 60px;">{row.user}</datatable-cell>\n            <datatable-cell name="detail" style="max-width: 60px;">{row.detail}</datatable-cell>\n            <datatable-cell name="date" style="max-width: 60px;">{row.date}</datatable-cell>\n          </datatable>\n        </div>\n      </div>\n    </yield>\n    <yield to="footer">\n      <button class="btn btn-default btn-embossed" onclick="{modalHide}" type="button">Закрыть</button>\n    </yield>\n  </bs-modal>\n', '', '', function(opts) {
'use strict';

var self = this;

self.logCols = [{ name: 'action', value: 'Действие' }, { name: 'user', value: 'Пользователь' }, { name: 'detail', value: 'Дополнительно' }, { name: 'date', value: 'Дата' }];

self.on('mount', function () {
    var modal = self.tags['bs-modal'];
    modal.mixin('change');
    modal.item = opts.item || {};
    self.update();
});
});


// WEBPACK FOOTER //
// ./pages/orders/order-edit.tag